import DispatcherEvent from '@carvana/merch-native/DispatcherEvent';
import { useCallback, useContext } from 'react';
import { useIsNative } from '~/context/common/DeviceContext';
import UserVehicleContext from '~/context/vdp/UserVehicleContext';
import { type PurchaseEventPayload } from '~/native/common/contracts';
import { sendMessageToNative } from '~/native/vdp/dispatchers';
import sendPurchaseMessageToNative from './sendPurchaseMessageToNative';

export default function useStartPurchase(
  url: string,
  eventPayload: PurchaseEventPayload
): () => void {
  const isNative = useIsNative();
  const { triggerEvent } = useContext(UserVehicleContext);

  return useCallback(() => {
    if (isNative) {
      sendMessageToNative(DispatcherEvent.LeaveFullscreen, {}); // Ensure fullscreen is exited before starting purchase
      sendPurchaseMessageToNative(DispatcherEvent.StartPurchase, eventPayload);
    } else {
      triggerEvent.purchase();
      window.location.href = url;
    }
  }, [eventPayload, isNative, triggerEvent, url]);
}
